export enum UploadLockRequestType {
  // NOTE: The numerical value is important for the priority lock to work correctly.  It is used to determine the order of the requests in the queue.
  ScanFile = 0,
  GenerateThumbnail = 1,
  DicomMatch = 2,
  CompressFile = 3,
  UploadFile = 4,
  AttachFile = 5,
}
